import React from 'react';

import Navigation from './Navbar';
import Hero from './Hero';
import About from './About';
import BackendTechs from './BackendTechs';
import Projects from './Projects';
import Skills from './Skills';
import HireMe from './HireMe';
import Footer from './Footer';

function App() {
  return (
    <>
      <Navigation></Navigation>
      <Hero></Hero>
      <About></About>
      <BackendTechs></BackendTechs>
      <Projects></Projects>
      <Skills></Skills>
      <HireMe></HireMe>
      <Footer></Footer>
    </>
  );
}

export default App;
